import * as i0 from '@angular/core';
import { Injectable, Component, Input, NgModule } from '@angular/core';
import { map, pluck, take, takeUntil } from 'rxjs/operators';
import { Subject, BehaviorSubject } from 'rxjs';
import * as i1 from '@angular/common/http';
import * as i1$1 from '@ngrx/store';
import * as i3 from 'ngx-toastr';
import * as i4 from 'app-services-library';
import * as i5 from '@angular/common';
import { PrimengLibraryModule } from 'primeng-library';

class CustomButtonActionService {
    constructor(httpClient) {
        this.httpClient = httpClient;
        this.onShowBeneficiaryProfile = new Subject();
        this.onLinkRedirectPageSubject = new Subject();
        this.actionNameSource = new BehaviorSubject(null);
        this.actionName$ = this.actionNameSource.asObservable();
    }
    postProceedEMP(payload) {
        return this.httpClient.post(`/vd/formBuilder/fbInvite/employee`, payload).pipe(map((response) => {
            if (response && response.status === 200) {
                return response;
            }
        }));
    }
    getProceedEMPId(fbEmployeeId) {
        return this.httpClient.get(`/vd/formBuilder/fbInviteEmployee/${fbEmployeeId}/employee`).pipe(map((response) => {
            if (response.status === 200 || response.status === 204) {
                return response;
            }
        }));
    }
    getPageFormById(pageBuilderId) {
        // return this.http.get(`/vd/formBuilder/${pageBuilderId}/createdPage`).pipe(
        return this.httpClient.get(`/vd/formBuilder/${pageBuilderId}/createdPageForm`).pipe(pluck('data'), map((data) => {
            return data;
        }));
    }
    setActionName(actionName) {
        this.actionNameSource.next(actionName);
    }
    getActionName() {
        return this.actionNameSource.getValue();
    }
}
CustomButtonActionService.ɵfac = function CustomButtonActionService_Factory(t) { return new (t || CustomButtonActionService)(i0.ɵɵinject(i1.HttpClient)); };
CustomButtonActionService.ɵprov = i0.ɵɵdefineInjectable({ token: CustomButtonActionService, factory: CustomButtonActionService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CustomButtonActionService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

const _c0 = function (a0) { return { "width": a0 }; };
class CustomButtonActionComponent {
    constructor(store, apiService, toastr, appServicesLibraryService) {
        this.store = store;
        this.apiService = apiService;
        this.toastr = toastr;
        this.appServicesLibraryService = appServicesLibraryService;
        this.disableBtn = true;
        this.userType = '';
        this.observableSubscription$ = new Subject();
        this.fbPayload = {};
    }
    ngOnInit() {
        var _a, _b;
        if (((_b = (_a = this.inputParams) === null || _a === void 0 ? void 0 : _a.properties) === null || _b === void 0 ? void 0 : _b.typeOfForm) === "FBFORM") {
            this.disableBtn = false;
        }
        else {
            this.group.valueChanges.subscribe((control) => {
                if (Object.values(control).some((x) => x.otherCode === 'EMPTYPE') &&
                    Object.values(control).some((x) => x.otherCode === 'EMPTYPECREATION' && String(x.name).toLowerCase() === 'single employee creation') &&
                    Object.values(control).some((x) => x.otherCode === 'EMPDATATOBEFILLED' && String(x.name).toLowerCase() === 'create yourself')) {
                    this.disableBtn = false;
                }
                else {
                    this.disableBtn = true;
                }
                // let count = 0;
                // Object.values(control).forEach((c: any) => {
                //   if (!c || !c.id) {
                //     count++
                //   }
                // });
                // setTimeout(() => {
                //   if (count === 0) {
                //     this.disableBtn = false;
                //   }
                // }, 0);
            });
        }
        this.fbPayload["moduleId"] = parseInt(sessionStorage.getItem("moduleId"));
        this.fbPayload["pageFormId"] = parseInt(sessionStorage.getItem("pageFormId"));
        this.userType = sessionStorage.getItem('userTypeRole');
    }
    ngAfterViewInit() {
        this.appServicesLibraryService.reportLoaded();
    }
    // toggleInputFields() {
    //   if (((this.userType === 'Petitioner' || this.userType === 'Attorney') && (this.inputData.stepStatusCode === 'COMPLETE' || this.inputData.stepStatusCode === 'NEW')) || (this.userType === 'Beneficiary' && (this.inputData.stepStatusCode === 'COMPLETE' || this.inputData.stepStatusCode === 'SUBMIT' || this.inputData.stepStatusCode === 'NEW'))) {
    //     this.disableBtn = true;
    //     this.group.disable();
    //   } else {
    //     this.disableBtn = false;
    //     this.group.enable();
    //   }
    // }
    performFormAction() {
        var _a, _b, _c, _d, _e;
        if (((_b = (_a = this.inputParams) === null || _a === void 0 ? void 0 : _a.properties) === null || _b === void 0 ? void 0 : _b.typeOfForm) === "FBFORM") {
            this.disableBtn = false;
            if ((_e = (_d = (_c = this.inputParams) === null || _c === void 0 ? void 0 : _c.properties) === null || _d === void 0 ? void 0 : _d.redirectTo) === null || _e === void 0 ? void 0 : _e.id) {
                this.apiService.getPageFormById(this.inputParams.properties.redirectTo.id)
                    .pipe(take(1)).subscribe((response) => {
                    if (response) {
                        const item = {
                            formType: response.buildFormatTypeId,
                            pageFormId: response.id
                        };
                        this.apiService.onLinkRedirectPageSubject.next(item);
                    }
                });
            }
        }
        else {
            Object.keys(this.group.controls).forEach((key) => {
                this.fbPayload[this.group.get(key).value.otherCode] = parseInt(this.group.get(key).value.id);
                if (this.group.get(key).value.otherCode === 'EMPDATATOBEFILLED') {
                    this.term = this.group.get(key).value.code;
                }
            });
            this.postEMPDetails();
        }
    }
    postEMPDetails() {
        this.payload = {
            employeeCreationType: this.fbPayload['EMPTYPECREATION'],
            employeeDataToBeFilled: this.fbPayload['EMPDATATOBEFILLED'],
            employeeType: this.fbPayload['EMPTYPE'],
            moduleId: this.fbPayload['moduleId'],
            pageFormId: this.fbPayload['pageFormId']
        };
        // localStorage.setItem("fbDetails", JSON.stringify(this.formBuilderObj));
        this.apiService.postProceedEMP(this.payload).pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response && response.status === 200) {
                this.toastr.success(response.message, 'Success');
                this.fbEmpId = response.data.id;
                this.landToURL(this.term);
            }
        });
    }
    landToURL(code) {
        switch (code) {
            case 'CREATEYOURSELF':
                this.apiService.onShowBeneficiaryProfile.next({
                    pageFrom: 'FB',
                    fbEmpId: this.fbEmpId
                });
                break;
        }
    }
}
CustomButtonActionComponent.ɵfac = function CustomButtonActionComponent_Factory(t) { return new (t || CustomButtonActionComponent)(i0.ɵɵdirectiveInject(i1$1.Store), i0.ɵɵdirectiveInject(CustomButtonActionService), i0.ɵɵdirectiveInject(i3.ToastrService), i0.ɵɵdirectiveInject(i4.AppServicesLibraryService)); };
CustomButtonActionComponent.ɵcmp = i0.ɵɵdefineComponent({ type: CustomButtonActionComponent, selectors: [["custom-button-action"]], inputs: { inputParams: "inputParams", inputData: "inputData", group: "group", pageBuilderInfo: "pageBuilderInfo" }, decls: 3, vars: 5, consts: [["type", "button", 1, "btn", "btn-primary", "btn-width", 3, "ngStyle", "disabled", "click"], [1, "common-bene-class-for-translation"]], template: function CustomButtonActionComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "button", 0);
        i0.ɵɵlistener("click", function CustomButtonActionComponent_Template_button_click_0_listener() { return ctx.performFormAction(); });
        i0.ɵɵelementStart(1, "span", 1);
        i0.ɵɵtext(2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(3, _c0, (ctx.inputParams == null ? null : ctx.inputParams.style == null ? null : ctx.inputParams.style.width) + " !important"))("disabled", ctx.disableBtn);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.inputParams.label);
    } }, directives: [i5.NgStyle], styles: [".btn-width[_ngcontent-%COMP%]{width:160px}.disableBtn[_ngcontent-%COMP%]{background-color:#dedede!important;color:#707070!important;cursor:not-allowed!important}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CustomButtonActionComponent, [{
        type: Component,
        args: [{
                selector: 'custom-button-action',
                templateUrl: 'custom-button-action.component.html',
                styleUrls: ['custom-button-action.component.scss']
            }]
    }], function () { return [{ type: i1$1.Store }, { type: CustomButtonActionService }, { type: i3.ToastrService }, { type: i4.AppServicesLibraryService }]; }, { inputParams: [{
            type: Input
        }], inputData: [{
            type: Input
        }], group: [{
            type: Input
        }], pageBuilderInfo: [{
            type: Input
        }] }); })();

class CustomButtonActionModule {
}
CustomButtonActionModule.ɵfac = function CustomButtonActionModule_Factory(t) { return new (t || CustomButtonActionModule)(); };
CustomButtonActionModule.ɵmod = i0.ɵɵdefineNgModule({ type: CustomButtonActionModule });
CustomButtonActionModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            PrimengLibraryModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(CustomButtonActionModule, { declarations: [CustomButtonActionComponent], imports: [PrimengLibraryModule], exports: [CustomButtonActionComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CustomButtonActionModule, [{
        type: NgModule,
        args: [{
                declarations: [CustomButtonActionComponent],
                imports: [
                    PrimengLibraryModule,
                ],
                exports: [CustomButtonActionComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of custom-button-action
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CustomButtonActionComponent, CustomButtonActionModule, CustomButtonActionService };
//# sourceMappingURL=custom-button-action.js.map
